var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectIconBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 12,
  viewBox: "0 0 21 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.53665 11.13L0 2.28663L1.92669 0.5L10.5 8.45004L19.0733 0.5L21 2.28663L11.4633 11.13C10.9313 11.6233 10.0687 11.6233 9.53665 11.13Z",
  fill: "#1B1B1B"
})));
export { SvgSelectIconBold as ReactComponent };
export default __webpack_public_path__ + "assets/37a0cf72.svg";